<template>
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M4 4L12 12M4 12L12 4"
            stroke="#333333"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>